import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";

var _context, _context2, _context3;
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2018. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */


import { ReduxUtils } from '@spm/core';
import Constants from '../App/constants';
import RESOURCE_NAMES from '../App/resources';
var GET_SUBMISSION_FORM_DETAILS_ACTION_TYPES = ReduxUtils.generateFetchActionTypes(Constants.LIBRARY_ROOT, RESOURCE_NAMES.submissionForm); // I have added the "_1" etc. because otherwise these will create the same action type data

var SUBMISSION_FORM_CREATE_SUBMISSION_FORM_ACTION_TYPES = ReduxUtils.generatePostActionTypes(Constants.LIBRARY_ROOT, _concatInstanceProperty(_context = "").call(_context, RESOURCE_NAMES.submissionForm, "_1"));
var SUBMISSION_FORM_GET_CURRENT_PAGE_DETAILS_ACTION_TYPES = ReduxUtils.generateFetchActionTypes(Constants.LIBRARY_ROOT, _concatInstanceProperty(_context2 = "").call(_context2, RESOURCE_NAMES.submissionForm, "_2"));
var SUBMISSION_FORM_SEND_CURRENT_PAGE_ANSWERS_ACTION_TYPES = ReduxUtils.generatePostActionTypes(Constants.LIBRARY_ROOT, _concatInstanceProperty(_context3 = "").call(_context3, RESOURCE_NAMES.submissionForm, "_3"));
export { GET_SUBMISSION_FORM_DETAILS_ACTION_TYPES, SUBMISSION_FORM_CREATE_SUBMISSION_FORM_ACTION_TYPES, SUBMISSION_FORM_GET_CURRENT_PAGE_DETAILS_ACTION_TYPES, SUBMISSION_FORM_SEND_CURRENT_PAGE_ANSWERS_ACTION_TYPES };